import { toast } from 'react-toastify';

export const isImageURL = (url: string) => {
  return url.match(/\.(jpeg|jpg|gif|png|tiff|bmp)$/) !== null;
};

export const saveDataToFile = (dataURL: string, fileName: string) => {
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = dataURL;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(dataURL);
  }, 100);
};

export const getDataTimeStringFormat = () => {
  const d = new Date();
  const date = d.toISOString().split('T')[0].replace(/-/g, '_');
  const time = d.toTimeString().split(' ')[0].replace(/:/g, '_');
  return `${date}_${time}`;
};

export const bytesToSize = (bytes: number) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i === 0) return bytes + ' ' + sizes[i];
  return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
};

export const copyMessageToClipboard = (text: string, message = 'Copied successfully ') => {
  navigator.clipboard.writeText(text).then(() => {
    toast.success(message, {
      autoClose: 1000,
      position: 'top-left',
      className: 'toast toast-black',
    });
  });
};
